// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsents_root__2ueiN","consentsList":"PatientConsents_consentsList__3pims","consentsListEmpty":"PatientConsents_consentsListEmpty__B6YQn"};